import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { getSingleData } from "../../Utils/CallApiUtils";
import { useLoadingContext } from "../../Loading/LoadingContext";
import UserSetting from "../../UserSettings.json";
import api from "../../Utils/api";
import { useCurrentPolicyContext } from "../../actions/CurrentPolicyContext";
import { decryptAndGetItemLocalStorage } from "../../Utils/cryptosessionStorage";
import { Row, Col, Form } from "react-bootstrap";
import PolicyCard from "../../Common/PolicyCard";
import InputGroupWithIcon from "../../Common/InputGroupWithIcon ";
import { SearchButton, ResetButton } from "../../Common/ToolbarButtons";
import Swal from "sweetalert2";
import Endorsement from "../Endorsement/Endorsement";
import Claim from "../Claim/Claim";
import Courier from "../Courier/Courier";
import "./Dashboard.css";

const emtSearchPolicy = {
  policyNo: "",
  netAmount: "",
  companyName: "",
  externalRemarks: "",
  policyHolderName: "",
};

const emtCount = {
  TotalPolicy: 0,
  TotalActivePolicy: 0,
  TotalExpiredPolicy: 0,
};

const Dashboard = () => {
  const loginUserMobileNo = decryptAndGetItemLocalStorage("_MNO_C");
  const [policyData, setPolicyData] = useState([]);
  const [storeAllPolicyData, setStoreAllPolicyData] = useState([]);
  const { setIsLoading } = useLoadingContext();
  const { currentSelectPolicyID, setCurrentSelectPolicyID, setCurrentSelectPolicyNo } =
    useCurrentPolicyContext();
  const [selectedValue, setSelectedValue] = useState("Active");
  const [options, setOptions] = useState([]);
  const policyTypeHadeRef = useRef();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchPolicyDetails, setSearchPolicyDetails] =
    useState(emtSearchPolicy);
  const [CountsPolicyAsType, setCountsPolicyAsType] = useState(emtCount);

  const [showEndorsementModel, setShowEndorsementModel] = useState(false);
  const [showClaimModel, setShowClaimModel] = useState(false);
  const [showCourierModel, setShowCourierModel] = useState(false);

  useEffect(() => {
    getPolicyDetail();
    setShowDropdown(false);
  }, [loginUserMobileNo]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getPolicyDetail = async () => {
    const Result = await getSingleData(
      `Policy/GetPolicyAllDataByClientMobileNo?clientMobileNo=${loginUserMobileNo}`,
      setStoreAllPolicyData,
      setIsLoading
    );
    if (Result) {
      const All = Result;
      const Actives = Result.filter((item) => !item.isPolicyExpired);
      const Expired = Result.filter((item) => item.isPolicyExpired);
      setPolicyData(Actives);
      setCountsPolicyAsType({
        TotalPolicy: All.length,
        TotalActivePolicy: Actives.length,
        TotalExpiredPolicy: Expired.length,
      });
    }
  };

  const CountViewPolicy = (id) => {
    api.get(`Policy/CountViewPolicyByClient?PolicyID=${id}`);
  };

  const handleChange = async (e) => {
    const value = e.target ? e.target.value : e;
    setSelectedValue(value);
  };

  const refreshSearchItem = () => {
    setSearchPolicyDetails(emtSearchPolicy);
    getPolicyDetail();
  };

  const handleSearchPolicyByActiveAndEx = (e) => {
    let filteredData = storeAllPolicyData;
    const value = e.target ? e.target.value : e;
    setSelectedValue(value);
  
    const now = new Date();
    const thirtyDaysAgo = new Date(now);
    thirtyDaysAgo.setDate(now.getDate() - 30);
    const thirtyDaysAfter = new Date(now);
    thirtyDaysAfter.setDate(now.getDate() + 30);
  
    switch (value) {
      case "Active":
        filteredData = filteredData.filter((item) => !item.isPolicyExpired);
        break;
  
      case "Expired":
        filteredData = filteredData.filter((item) => item.isPolicyExpired);
        break;
  
      case "30DayExpired":
        filteredData = filteredData.filter((item) => 
          new Date(item.policyEndDate) >= thirtyDaysAgo &&
          new Date(item.policyEndDate) <= thirtyDaysAfter &&
          !item.renewalFlag
        );
        break;
  
      default:
        filteredData = filteredData;
        break;
    }
  
    setPolicyData(filteredData);
    setShowDropdown(false);
  };
  

  const handleSearchPolicy = () => {
    var filteredData = storeAllPolicyData;
    // const value = selectedValue;

    // switch (value) {
    //   case "Active":
    //     filteredData = filteredData.filter((item) => !item.isPolicyExpired);
    //     break;

    //   case "Expired":
    //     filteredData = filteredData.filter((item) => item.isPolicyExpired);
    //     break;

    //   default:
    //     filteredData = filteredData;
    //     break;
    // }

    if (searchPolicyDetails.policyNo !== "") {
      filteredData = filteredData.filter((item) =>
        item.policyNo
          .toUpperCase()
          .includes(searchPolicyDetails.policyNo.toUpperCase())
      );
    }

    if (searchPolicyDetails.netAmount !== "") {
      filteredData = filteredData.filter(
        (item) => item.netAmount == searchPolicyDetails.netAmount
      );
    }

    if (searchPolicyDetails.companyName !== "") {
      filteredData = filteredData.filter((item) =>
        item.insuranceCompanyName
          ?.toUpperCase()
          .includes(searchPolicyDetails.companyName.toUpperCase())
      );
    }

    if (searchPolicyDetails.externalRemarks !== "") {
      filteredData = filteredData.filter((item) =>
        item.externalRemarks
          ?.toUpperCase()
          .includes(searchPolicyDetails.externalRemarks.toUpperCase())
      );
    }

    if (searchPolicyDetails.policyHolderName !== "") {
      filteredData = filteredData.filter((item) =>
        item.policyHolderName
          ?.toUpperCase()
          .includes(searchPolicyDetails.policyHolderName.toUpperCase())
      );
    }
    setPolicyData(filteredData);

    setShowDropdown(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSearchPolicyDetails({ ...searchPolicyDetails, [name]: value });
  };

  const resetFilter = () => {
    setSearchPolicyDetails(emtSearchPolicy);
    setSelectedValue("Active");
    getPolicyDetail();
  };

  const SendSMSAndEmail = (id) => {
    setIsLoading(true);
    api
      .get(`Policy/SendEmailAndWhatsAppPolicyByClientSide?PolicyID=${id}`)
      .then((Result) => {
        Swal.fire({
          icon: "success",
          title: Result.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  // Declared once and rendered into both the desktop row and the mobile sheet.
  // The old page spelled each field out twice, so the two copies had already
  // drifted apart.
  const filters = [
    { label: "PolicyNo", name: "policyNo", icon: "fa fa-hashtag" },
    { label: "Net Amt.", name: "netAmount", icon: "fa fa-money" },
    { label: "Company", name: "companyName", icon: "fa fa-building" },
    { label: "External Re.", name: "externalRemarks", icon: "fa fa-sticky-note" },
    { label: "Insured Name", name: "policyHolderName", icon: "fa fa-user" },
  ];

  const activeFilterCount = Object.values(searchPolicyDetails).filter(
    (v) => v !== ""
  ).length;

  // Original .inputBox treatment kept exactly as-is — the caption sits on the
  // border, which is what keeps this row to a single line.
  const filterFields = (colSize) =>
    filters.map((f) => (
      <InputGroupWithIcon
        key={f.name}
        Label={f.label}
        ColSize={colSize}
        type="text"
        name={f.name}
        icon={f.icon}
        value={searchPolicyDetails[f.name]}
        onChange={handleInputChange}
        onKeyPress={(e) => {
          if (e.key === "Enter") handleSearchPolicy();
        }}
      />
    ));

  const statusSelect = (
    <Form.Select
      aria-label="Show policies by status"
      value={selectedValue}
      onChange={handleSearchPolicyByActiveAndEx}
    >
      <option value="All">All {CountsPolicyAsType.TotalPolicy}</option>
      <option value="Active">Active {CountsPolicyAsType.TotalActivePolicy}</option>
      <option value="Expired">Expired {CountsPolicyAsType.TotalExpiredPolicy}</option>
      <option value="30DayExpired">30DayExpired</option>
    </Form.Select>
  );

  const filterActions = (
    <div className="dash__filter-actions">
      <SearchButton onClick={handleSearchPolicy} ariaLabel="Search policies" />
      <ResetButton onClick={resetFilter} />
    </div>
  );

  return (
    <>
      <div className="dash">
        {/* Sticky, because on a long list the filters are the way back out.
            The 1 + (5 x 2) + 1 column split is the original one — it is what
            keeps all seven controls on a single line at lg and up. */}
        <div className="dash__filters">
          {!isMobile ? (
            <Row className="dash__filter-row mx-0 align-items-center">
              <Col md={4} sm={4} lg={1} className="dash__filter-status">
                {statusSelect}
              </Col>
              {filterFields({ md: 4, sm: 4, lg: 2 })}
              <Col md={12} sm={12} lg={1} className="d-flex align-items-center">
                {filterActions}
              </Col>
            </Row>
          ) : (
            <>
              <button
                type="button"
                className="dash__filter-toggle"
                onClick={() => setShowDropdown(!showDropdown)}
                aria-expanded={showDropdown}
                aria-controls="dash-filter-sheet"
              >
                <span>
                  <i className="fa fa-sliders" aria-hidden="true"></i> Filter policies
                  {activeFilterCount > 0 && ` (${activeFilterCount})`}
                </span>
                <i
                  className={`fa ${showDropdown ? "fa-chevron-up" : "fa-chevron-down"}`}
                  aria-hidden="true"
                ></i>
              </button>
              {showDropdown && (
                <Row className="dash__filter-sheet mx-0" id="dash-filter-sheet">
                  <Col xs={12} className="mb-2">
                    {statusSelect}
                  </Col>
                  {filterFields({ xs: 12, sm: 6, md: 6, lg: 6 })}
                  <Col xs={12} className="mt-2">
                    {filterActions}
                  </Col>
                </Row>
              )}
            </>
          )}
        </div>

        <div className="dash__summary">
          <h1 className="dash__summary-title">Your policies</h1>
          <p className="dash__summary-count">
            Showing <strong>{policyData.length}</strong> of{" "}
            <strong>{CountsPolicyAsType.TotalPolicy}</strong>
          </p>
        </div>

        <div className="dash__grid">
          {policyData.length > 0 ? (
            policyData.map((item) => (
              <PolicyCard
                key={item.policyID}
                item={item}
                documentUrl={item.imagePath && UserSetting.imgURL + item.imagePath}
                onViewPolicy={() => CountViewPolicy(item.policyID)}
                onSendPolicy={() => SendSMSAndEmail(item.policyID)}
                /* The number travels with the id so each sheet can name the
                   policy even when it has no rows to draw it from. */
                onCourier={() => {
                  setCurrentSelectPolicyID(item.policyID);
                  setCurrentSelectPolicyNo(item.policyNo);
                  setShowCourierModel(true);
                }}
                onEndorsement={() => {
                  setCurrentSelectPolicyID(item.policyID);
                  setCurrentSelectPolicyNo(item.policyNo);
                  setShowEndorsementModel(true);
                }}
                onClaim={() => {
                  setCurrentSelectPolicyID(item.policyID);
                  setCurrentSelectPolicyNo(item.policyNo);
                  setShowClaimModel(true);
                }}
              />
            ))
          ) : (
            /* An empty screen is an invitation to act. The old copy was
               "Not Any Policy Found!" in large red bold, which reads as a
               fault when the usual cause is a filter that is too narrow. */
            <div className="dash__empty">
              <span className="dash__empty-icon">
                <i className="fa fa-folder-open" aria-hidden="true"></i>
              </span>
              <h2 className="dash__empty-title">No policies to show</h2>
              <p className="dash__empty-text">
                Nothing matches these filters. Try widening the search, or reset
                it to see every policy on your number.
              </p>
              <button
                type="button"
                className="ui-btn ui-btn--outline ui-btn--sm"
                onClick={resetFilter}
              >
                Reset filters
              </button>
            </div>
          )}
        </div>
      </div>

      <Modal
        show={showEndorsementModel}
        onHide={() => setShowEndorsementModel(false)}
        dialogClassName="modal-dialog-scrollable"
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title>Endorsements</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Endorsement />
        </Modal.Body>
      </Modal>

      <Modal
        show={showClaimModel}
        onHide={() => setShowClaimModel(false)}
        dialogClassName="modal-dialog-scrollable"
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title>Claims</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Claim />
        </Modal.Body>
      </Modal>

      <Modal
        show={showCourierModel}
        onHide={() => setShowCourierModel(false)}
        dialogClassName="modal-dialog-scrollable"
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title>Courier tracking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Courier />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Dashboard;
